import React from "react";

const Footer = () => {
  let d = new Date();
  return (
    <div className="footer bdy "  >
      <div className="copyright">
        <p style={{  color: "#3E4465"}}> 
          Copyright © Designed &amp; Developed by{" "} CAAD
          
            
   {" "}
          {d.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
